import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ResumeDetailService } from './resume-detail.service';
import { ResumeDetailComponent } from './resume-detail.component';
import { SelectOptionModule } from '../../select-option/select-option.module';
import { DialogModule, CalendarModule } from 'primeng/primeng';
//组件
import { SharedModule } from '../../../shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    DialogModule,
    SelectOptionModule,
    CalendarModule,
  ],
  declarations: [ResumeDetailComponent],
  providers: [ResumeDetailService],
  exports: [ResumeDetailComponent]
})
export class ResumeDetailModule { }



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/user/company/resume-detail/resume-detail.module.ts